import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import propTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { useSelector } from 'react-redux';
import sSubHeader from './subHeader.scss';
import GenericActionsSelect from '../selects/genericActionsSelect';
import DeletePlanDialog from '../pageWrappers/overview/DeletePlanDialog';

function SubHeader(props) {
  const selectedPlan = useSelector(state => state.plans.plan);
  const permissions = useSelector(state => state.profile.permissions);
  const [selectedAction, setSelectedAction] = useState(null);
  
  const actionOptions = [
    {
      label: 'Delete Plan',
      value: '1',
    },
  ];

  return (
    <>
      <div className={sSubHeader.subheader}>
        {!props.traveler ? (
          <div className={sSubHeader['subheader-content']}>
            <div className={sSubHeader['left-section']}>
              <div className={sSubHeader.item}>
                <NavLink
                  className={sSubHeader.selection}
                  to="/plans/plan-list"
                  activeClassName={sSubHeader.selected}
                >
                  PLANS
                </NavLink>
              </div>
              <div className={sSubHeader.item}>
                <NavLink
                  className={sSubHeader.selection}
                  to="/plans/traveler-list"
                  activeClassName={sSubHeader.selected}
                >
                  TRAVELERS
                </NavLink>
              </div>
              <div className={sSubHeader.item}>
                <NavLink
                  className={sSubHeader.selection}
                  to="/safecheck/messages"
                  activeClassName={sSubHeader.selected}
                >
                  SAFECHECK
                </NavLink>
              </div>
            </div>
            {props?.as === "admin" && (
              <div className={sSubHeader['right-section']}>
                <GenericActionsSelect
                  options={actionOptions}
                  isDisabled={!permissions?.travel_plans_settings?.includes('delete_plans')}
                  placeholder="Actions"
                  value={selectedAction}
                  onChange={e => {
                    setSelectedAction(e.value);
                  }}
                />
              </div>
            )}
          </div>
        ) : (
          <div className={sSubHeader['subheader-content']}>
            <div className={sSubHeader.item}>
              <NavLink
                className={sSubHeader.selection}
                to="/plans/my-travel"
                activeClassName={sSubHeader.selected}
              >
                MY TRAVEL
              </NavLink>
            </div>
            <div className={sSubHeader.item}>
              <NavLink
                className={sSubHeader.selection}
                to="/plans/group-travel-search"
                activeClassName={sSubHeader.selected}
              >
                GROUP TRAVEL SEARCH
              </NavLink>
            </div>
            <div className={sSubHeader.item}>
              <NavLink
                className={sSubHeader.selection}
                to="/safecheck/phone"
                activeClassName={sSubHeader.selected}
              >
                SAFECHECK
              </NavLink>
            </div>
          </div>
        )}
      </div>

      <DeletePlanDialog
        show={selectedAction === '1'}
        planName={selectedPlan?.plan?.attributes?.name}
        planId={selectedPlan?.plan?.id}
        handleClose={() => {
          setSelectedAction(null);
        }}
      />
    </>
  );
}

SubHeader.propTypes = {
  traveler: propTypes.bool.isRequired,
  as: propTypes.string,
};

export default withStyles(sSubHeader)(SubHeader);
